import React from "react"

import { Text, Header } from "ui-Text"

export default function InsuranceNote() {
  return (
    <div>
      <Header>Payments &amp; Insurance</Header>
      <Text>
        I accept Check, Cash or Credit Card. All consultations will include a superbill you can
        submit to your insurance provider for reimbursement.
      </Text>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/ServicePaymentOptions/index.js